function isPlainObject(value: unknown): value is object {
    if (typeof value !== 'object' || value === null) return false

    let proto = Object.getPrototypeOf(value)
    if (proto === null) return true

    let baseProto = proto
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto)
    }

    return proto === baseProto
}

export function isSerializable(val: any) {
    return (
        typeof val === 'undefined' ||
        val === null ||
        typeof val === 'string' ||
        typeof val === 'boolean' ||
        typeof val === 'number' ||
        Array.isArray(val) ||
        isPlainObject(val)
    )
}
